<template>
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <div class="flex-1 bold fs-18">
          {{ agentName || '' }}
        </div>
        <div class="date_section">
          <div class="block mr10">
            <el-date-picker v-model="value1" type="date" value-format="yyyy-MM-dd" placeholder="开始时间">
            </el-date-picker>
          </div>
          <div class="block mr10">
            <el-date-picker v-model="value2" type="date" value-format="yyyy-MM-dd" placeholder="结束时间">
            </el-date-picker>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shopSupplierId" label="ID" width="60"></el-table-column>
          <el-table-column prop="name" label="商户名称" min-width="100"></el-table-column>
          <el-table-column prop="shopName" label="店铺名称" min-width="100"></el-table-column>
          <el-table-column prop="orderTotal" label="订单数量" min-width="90"></el-table-column>
          <el-table-column prop="saleMoney" label="商品销售额"
                           min-width="90"></el-table-column>
          <el-table-column prop="expressPrice" label="运费" min-width="90"></el-table-column>
          <el-table-column prop="platRetentionMoney" label="平台留存" min-width="90"></el-table-column>
          <el-table-column prop="agentMoney" label="佣金" min-width="90"></el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CashApi from '@/api/cash.js'
import qs from 'qs'
import {getCookie} from '@/utils/base.js'

export default {
  name: 'index',
  data () {
    return {
      agentId: 0,
      agentName: '',
      /*是否加载完成*/
      loading: false,
      /*列表数据*/
      tableData: [],
      value1: '',
      value2: '',
      formInline: {},
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.agentId = parseInt(this.$route.query.id || 0)
      this.agentName = this.$route.query.agentName || ''
      this.getTableList()
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getTableList()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },
    /**
     * 获取分销商统计信息
     */
    getTableList () {
      let self = this
      let Params = this.formInline
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.agentId = self.agentId
      CashApi.getSupplierStatistics(Params, true).then(res => {
        self.tableData = res.data.records
        self.totalDataNumber = res.data.total
        self.loading = false
      }).catch(error => {
        self.loading = false
      })
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.formInline.startDay = this.value1
      this.formInline.endDay = this.value2
      this.getTableList()
    },
    onExport () {
      let self = this
      let Params = {}
      Params.startDay = this.value1
      Params.endDay = this.value2
      if (this.agentId) {
        Params.agentId = this.agentId
      }
      Params.token = getCookie('token')
      // let baseUrl = window.location.protocol + '//' + window.location.host
      window.location.href = process.env.BASE_API + 'shop/cash/cash/export?' + qs.stringify(Params)
    }
  }
}
</script>

<style lang="scss" scoped>
.date_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 18px;
}

.demo-form-inline {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/cash/distributor/detail.vue